//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import RoleModal from "./modules/RoleModal";
import UserRoleModal from "./modules/UserRoleModal";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import JDate from '@/components/jeecg/JDate';
export default {
  name: "RoleList",
  mixins: [JeecgListMixin],
  components: {
    RoleModal: RoleModal,
    UserRoleModal: UserRoleModal,
    JDate: JDate
  },
  data: function data() {
    return {
      description: '角色管理页面',
      // 查询条件
      queryParam: {
        roleName: ''
      },
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: "center",
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        title: '角色名称',
        align: "center",
        dataIndex: 'roleName'
      }, {
        title: '角色编码',
        align: "center",
        dataIndex: 'roleCode'
      }, {
        title: '备注',
        align: "center",
        dataIndex: 'description'
      }, {
        title: '排序',
        align: "center",
        dataIndex: 'sortOrder'
      }, {
        title: '创建时间',
        dataIndex: 'createTime',
        align: "center",
        sorter: true
      }, {
        title: '更新时间',
        dataIndex: 'updateTime',
        align: "center",
        sorter: true
      }, {
        title: '操作',
        dataIndex: 'action',
        align: "center",
        scopedSlots: {
          customRender: 'action'
        }
      }],
      url: {
        list: "/sys/role/list",
        delete: "/sys/role/delete",
        deleteBatch: "/sys/role/deleteBatch",
        exportXlsUrl: "/sys/role/exportXls",
        importExcelUrl: "sys/role/importExcel"
      }
    };
  },
  computed: {
    importExcelUrl: function importExcelUrl() {
      return "".concat(window._CONFIG['domianURL'], "/").concat(this.url.importExcelUrl);
    }
  },
  methods: {
    handlePerssion: function handlePerssion(roleId) {
      // alert(roleId);
      this.$refs.modalUserRole.show(roleId);
    },
    onDate: function onDate(value, dateArray) {
      this.queryParam.sdate = dateArray[0];
      this.queryParam.edate = dateArray[1];
    }
  }
};